import DateLocaleFormatter from './date-locale-formatter';
import { createAlphanumericFormatter } from '@philips-internal/oswald-ui-model/lib/generators/';
import EmployerIdentificationNumberFormatter from './employer-identification-number-formatter';
import MedicareFormatter from './medicare-formatter';
import { ARGENTINA_CUIL, ARGENTINA_DNI, argentinaCUIL, argentinaDNI } from './validator/argentina-validators';
import { ALPHA_NUMERIC_NEW, alphaNumericNew, BIRTH_DATE_VALIDATOR, birthdayValidator, BOOLEAN_REQUIRED, booleanRequired, CRYPTOPW_CONFIRM_VALIDATOR, CRYPTOPW_VALIDATOR, cryptoPWConfirmValidator, cryptoPWValidator, EMAIL_ALREADY_EXISTS_VALIDATOR, EMAIL_VALIDATOR, emailAlreadyExistsValidator, emailValidator, REQUIRED_FILE_DESCRIPTION, requiredFileDescriptionValidator, TEXTAREA_VALIDATOR, textareaValidator, USERNAME_VALIDATOR, usernameValidator, } from './validator/validators';
import { ModelService } from '@philips-internal/oswald-ui-core/lib/services';
ModelService.registerFormatter('alphaNumeric', createAlphanumericFormatter({
    invalidMessage: '',
    mask: /^[a-zA-Z0-9]*$/,
    name: 'alphaNumeric',
    validate: () => true
}));
ModelService.registerFormatter('employee-identification-number', EmployerIdentificationNumberFormatter);
ModelService.registerFormatter('medicare-formatter', MedicareFormatter);
ModelService.registerValidator(EMAIL_VALIDATOR, emailValidator);
ModelService.registerValidator(EMAIL_ALREADY_EXISTS_VALIDATOR, emailAlreadyExistsValidator);
ModelService.registerValidator(CRYPTOPW_VALIDATOR, cryptoPWValidator);
ModelService.registerValidator(CRYPTOPW_CONFIRM_VALIDATOR, cryptoPWConfirmValidator);
ModelService.registerValidator(BOOLEAN_REQUIRED, booleanRequired);
ModelService.registerValidator(BIRTH_DATE_VALIDATOR, birthdayValidator);
ModelService.registerValidator(TEXTAREA_VALIDATOR, textareaValidator);
ModelService.registerValidator(USERNAME_VALIDATOR, usernameValidator);
ModelService.registerValidator(REQUIRED_FILE_DESCRIPTION, requiredFileDescriptionValidator);
ModelService.registerValidator(ALPHA_NUMERIC_NEW, alphaNumericNew);
ModelService.registerValidator(ARGENTINA_DNI, argentinaDNI);
ModelService.registerValidator(ARGENTINA_CUIL, argentinaCUIL);
export { DateLocaleFormatter, EmployerIdentificationNumberFormatter, MedicareFormatter, };
//# sourceMappingURL=index.js.map